import * as types from "./types";
import { createReducer } from "../../util/index";

const initialState = {};

const dailyCheckInReducer = createReducer(initialState)({
  [types.DAILY_CHECK_IN_MEMBER_PROGRESS]: (state, action) => ({
    ...state,
    memberProgress: action.payload,
  }),
  [types.DAILY_CHECK_IN_CHECK_IN]: (state, action) => ({
    ...state,
    checkIn: action.payload,
  }),
  [types.DAILY_CHECK_IN_CLEAR_PROGRESS]: (state, action) => ({
    ...state,
    clearProgress: action.payload,
  }),
});

export default dailyCheckInReducer;
